import { Routes, Route } from 'react-router-dom'
import { MainLayout } from './components/layout/MainLayout'
import { AppProvider } from './components/providers/app-provider'
import { Dashboard } from './pages/Dashboard'
import { PatientList } from './features/patients/components/PatientList'
import { VisitsPage } from './features/visits/pages/VisitsPage'
import { InventoryPage } from './features/inventory/pages/InventoryPage'
import { OutreachPage } from './features/outreach/pages/OutreachPage'
import Settings from './pages/Settings'

export default function App() {
  return (
    <AppProvider>
        <MainLayout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/patients" element={<PatientList />} />
            <Route path="/visits/*" element={<VisitsPage />} />
            <Route path="/inventory" element={<InventoryPage />} />
            <Route path="/outreach" element={<OutreachPage />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
        </MainLayout>
    </AppProvider>
  )
}
